import React from "react";

const addCurrencyMask = (e) => {
  let value = e.target.value;
  value = value.replace(/\D/g, "");
  value = value.replace(/(\d)(\d{2})$/, "$1,$2");
  value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");
  e.target.value = value;
  return e;
};

const parseAmount = (amount) => {
  if (amount) {
    amount = amount.replace(/\./g, "");
    amount = amount.replace(/,/g, ".");
    return parseFloat(amount);
  }

  return 0;
};

const isCandidatureOptionChecked = (ids, id) => {
  return ids?.includes(parseInt(id));
};

const updateCheckedOptions = (items, id, checked) => {
  if (checked) {
    if (!items.includes(parseInt(id))) {
      items.push(parseInt(id));
    }
  } else {
    for (var i = 0; i < items.length; i++) {
      if (items[i] === parseInt(id)) {
        items.splice(i, 1);
      }
    }
  }

  return items;
};

const checkHasOwnBusiness = (occupations, id) => {
  return occupations && occupations.includes(id);
};

const checkIsEmployed = (occupations, ids) => {
  return occupations && occupations.some((id) => ids.includes(id));
};

const getDocumentTypeDescription = (docType) => {
  const descriptions = {
    COMPANY_EXPERIENCE: "Experiência da Empresa",
    PROJECT_TIMELINE: "Cronograma do Projeto",
    INVESTMENT_MAP: "Mapa de Investimentos",
    MEMBER_CV: "Currículo do Membro",
    MEMBER_CERTIFICATIONS: "Certificações do Membro",
    USER_MANUAL: "Manual do Utilizador",
    TECHNICAL_DOCUMENTATION: "Documentação Técnica",
    PRESENTATION: "Apresentação",
    COMPLEMENTARY_MATERIAL: "Material Complementar",
  };

  return descriptions[docType] || "Tipo de documento desconhecido";
};

export {
  updateCheckedOptions,
  checkHasOwnBusiness,
  checkIsEmployed,
  isCandidatureOptionChecked,
  addCurrencyMask,
  parseAmount,
  getDocumentTypeDescription,
};
